import { defineType } from "sanity";

export default defineType({
  name: "imageWithAlt",
  type: "image",
  title: "Image",
  options: {
    hotspot: true
  },
  fields: [
    {
      name: "alt",
      type: "multilingualArrayString",
      title: "Alternative text",
      description: "Important for SEO and accessibility.",
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  preview: {
    select: {
      imageUrl: "asset.url",
      title: "alt"
    }
  }
});
